export default "__VITE_ASSET__C79RiclG__"